import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { useGetAccessToken } from '../api/queries/useGetAccessToken';
import { useAuthStore } from '../stores/authStore';
import { extractEmailAndLoginTokenFromURL } from '../utils/auth';

type ProtectedRouteProps = {
  checkIsAdmin?: boolean;
};

const ProtectedRoute = ({ checkIsAdmin }: ProtectedRouteProps) => {
  const isAdmin = useAuthStore((state) => state.isAdmin);
  const accessToken = useAuthStore((state) => state.accessToken);
  const setIsAuthComplete = useAuthStore((state) => state.setIsAuthComplete);
  const { mutate: getAccessToken, isError } = useGetAccessToken();
  const url = new URL(window.location.href);
  const urlAuth = url.searchParams.get('auth');
  const loginPayload = extractEmailAndLoginTokenFromURL(urlAuth || '');

  useEffect(() => {
    if (loginPayload) {
      getAccessToken(loginPayload);
    } else {
      setIsAuthComplete(true);
    }
  }, []);

  if (isError) {
    return <Navigate to='/invalid-login' replace />;
  }
  if (!loginPayload && !accessToken) {
    return <Navigate to='/login' replace />;
  }
  if (checkIsAdmin && !isAdmin) {
    return <Navigate to='/error' replace />;
  }

  return <Outlet />;
};

export { ProtectedRoute };
